import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Typography, Container, Paper, Box } from '@mui/material';
import PageLayout from '../components/PageLayout';

function ChampionsLeagueLandingPage() {
    const handleStartAuctionClick = () => {
        alert('Op dit moment niet beschikbaar');
    };

    return (
        <PageLayout>
            <Container component="main" maxWidth="sm">
                <Paper
                    elevation={6}
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: 4
                    }}
                >
                    <Typography component="h1" variant="h4" gutterBottom>
                        Champions League Veiling
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph align="center">
                        Kies hieronder of je een nieuwe Champions League veiling wilt starten of wilt deelnemen aan een bestaande veiling.
                    </Typography>
                    <Box sx={{ mt: 3, width: '100%' }}>
                        <Button
                            variant="contained"
                            fullWidth
                            size="large"
                            onClick={handleStartAuctionClick}
                            disabled // Disable the button
                            sx={{ mb: 2 }}
                        >
                            Een veiling starten
                        </Button>
                        <Button
                            component={RouterLink}
                            to="/join-auction" // Link to the JoinAuction page
                            variant="outlined"
                            fullWidth
                            size="large"
                        >
                            Deelnemen aan een veiling
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </PageLayout>
    );
}

export default ChampionsLeagueLandingPage;